import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=30c6d9c2&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=ts"
export * from "./Tasks.vue?vue&type=script&lang=ts"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=30c6d9c2&prod&lang=scss&scoped=true"
import style1 from "./Tasks.vue?vue&type=style&index=1&id=30c6d9c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6d9c2",
  null
  
)

export default component.exports